import GenericDialog, {
  DialogButtonAction,
} from "@/components/StoreComponents/StoreDialogs/GenericDialog";
import { MOBILE_SCREEN_SIZE, TABLET_SCREEN_SIZE } from "@brandclub/common-ui";
import { QualifyingOrderPurchaseType } from "./DealTypeButton";

const DailyDealContent = {
  [QualifyingOrderPurchaseType.InStoreAndOnline]: {
    title: "Online & in-store daily deals",
    message:
      "Buy the featured product online or in-store using your retailer account and immediately sync your purchase to claim the daily deal reward while supplies last.",
    confirmText: "Close",
  },
  [QualifyingOrderPurchaseType.OnlineOnly]: {
    title: "Online daily deals",
    message:
      "Buy the featured product online using your retailer account and immediately sync your purchase to claim the daily deal reward while supplies last.",
    confirmText: "Close",
  },
  [QualifyingOrderPurchaseType.InStoreOnly]: {
    title: "In-store daily deals",
    message:
      "Buy the featured product in-store using your retailer account and immediately sync your purchase to claim the daily deal reward while supplies last.",
    confirmText: "Close",
  },
};

export const showDailyDealDialog = (
  purchaseType: QualifyingOrderPurchaseType,
  callback?: (newState: Readonly<any>) => void
) => {
  const actions: DialogButtonAction[] = [
    {
      text: "Close",
      variant: "solid",
    },
  ];

  GenericDialog.show({
    title: DailyDealContent[purchaseType]?.title ?? "Daily deal reward",
    text:
      DailyDealContent[purchaseType]?.message ??
      "Buy and sync the featured product to claim your daily deal reward while supplies last.",
    textProps: {
      sx: {
        marginBottom: "30px",
        [`@media screen and (max-width: ${TABLET_SCREEN_SIZE}px)`]: {
          marginTop: "10px",
        },
        [`@media screen and (max-width: ${MOBILE_SCREEN_SIZE}px)`]: {
          fontSize: 12,
        },
      },
    },
    actionsProps: {
      sx: {
        "&.actions": {
          [`@media screen and (max-width: ${TABLET_SCREEN_SIZE}px)`]: {
            flexDirection: "column-reverse",
            button: {
              height: 44,
              fontSize: 14,
              maxWidth: 355,
            },
          },
        },
      },
    },
    actions,
    listener: callback,
  });
};
